import { render } from "./DecisionStartView.vue?vue&type=template&id=7536ebe0&scoped=true"
import script from "./DecisionStartView.vue?vue&type=script&lang=js"
export * from "./DecisionStartView.vue?vue&type=script&lang=js"

import "./DecisionStartView.vue?vue&type=style&index=0&id=7536ebe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7536ebe0"]])

export default __exports__